export const environment = {
    production: false,
    url: 'https://dev.partiri.cloud',
    apiUrl: 'https://devapi.partiri.cloud',
    supaApiUrl: 'https://sdsupabase.partiri.cloud',
    supaApiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzQzMDMzNjAwLCJleHAiOjE5MDA4MDAwMDB9.yDCVaU965IJdzflHj743-GEld5hFsdzqpij5Z3wTJro',
    bugsinkDSN: 'https://af181005a3ff493f963ffd8cb8f36eff@plage52778.partitur.cloud/2',
    mcpCallbackOrigins: ['https://mcp.partiri.cloud'],
    mobileCallbackSchemes: ['lessd'],
    // Billing/payment kill switches (default on; set to false to disable).
    paymentsEnabled: true,
    mollieEnabled: true,
    nowpaymentsEnabled: true,
    notificationsEnabled: true,
};
